import { Box, styled } from '@mui/material';

export const Center = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignSelf: 'center',
});
